import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
// import ButtonBasic from '@/components/form/ButtonBasic.vue';
// import ToggleComponent from '@/components/form/ToggleComponent.vue';
//   import { ref } from 'vue';

export default {
  name: 'CustomerGender',
  components: {
    // ButtonBasic,
    // ToggleComponent,
  },
  mounted: function mounted() {
    console.log('<<<<<<<<< CustomerGender mounted >>>>>>>>>');
  },
  methods: {
    nextPage: function nextPage(value) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log('<<<<< trying to hit next on customer gender');
              _this.$store.commit('updateCustomerGender', value);
              _context.next = 4;
              return _this.$store.dispatch("saveProfileToDB");
            case 4:
              _this.$store.commit('stopIntroPage', 'CustomerGender');
              _this.$store.commit('startIntroPage', 'Gallery');
              console.log('<<<< after the fact');
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  setup: function setup() {},
  data: function data() {
    return {};
  }
};